import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card, Button, Typography } from "@material-ui/core";
import { FormControl, InputLabel, Select } from "@material-ui/core";

import DateFnsUtils from "@date-io/date-fns";
import "date-fns";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";

import SearchIcon from "@material-ui/icons/Search";


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "flex-start",
        backgroundColor: "#fafafc",
        paddingBottom: "0px!important",
        marginBottom: 30
    },
    cardContent: {
        width: "100%",
        minWidth: 300,
        color: "white!important",
        background: "white",
    },
    divider: {
        maxHeight: 2,
        marginTop: 20,
        marginBottom: 20,
        opacity: "0.1",
        background: "#868689",
        height: "1px!important",
        justifyContent: "center"
    },
    option: {
        color: "black",
    },
    datePicker: {
        marginLeft: 10,
        marginRight: 10,
        height: 30,
        width: 140,
        alignItems: "center",
        justifyContent: "center",
    },
    formControl: {
        backgroundColor: "white",
        alignItems: "center",
        justifyContent: "center",
        height: 30,
    },
    selector: {
        height: 30,
        background: "white",
        marginTop: 10,
        marginBottom: 10
    },
    componentStyle: {
        verticalAlign: "middle",
        fontSize: 15,
        width: 170,
        "& .MuiInputBase-root": {
            height: 10,
        },
        height: 30
    },
    createControlPointButton: {
        marginTop: 15,
        height: 30,
        width: 130,
        backgroundColor: "#def2fb",
        color: "#55c9f4",
        fontWeight: "bold!important",
        textTransform: "capitalize!important",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#55c9f4!important",
            color: "#ffffff!important",
        },
    },
    filterTitle: {
        fontSize: 10,
        color: "black"
    },
    title: {
        backgroundColor: "#fafafc",
        textTransform: "capitalize",
        color: "rgba(66,64,64,0.5)",
        fontWeight: "bold",
        fontSize: "14pt",
        marginBottom: "0px",
    },
}));

const emptyUser = {
    email: "-",
    key: null,
};

const eventOptions = [
    {
        label: "-",
        type: null,
        id: 0
    },
    {
        label: "Ingreso",
        type: "IN",
        id: 1
    },
    {
        label: "Egreso",
        type: "OUT",
        id: 2
    }
];

const sortOrientations = [
    {
        label: "ASC",
        type: "ASC",
        id: 0
    },
    {
        label: "DSC",
        type: "DSC",
        id: 1
    }
];

const getFirstDayOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
}

const getLastDayOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0);
}

const ControlPointActivityFilter = ({
    controlPoint,
    controlPointUsers,
    onSearch,
}) => {
    const classes = useStyles();
    const [localControlPoint, setControlPoint] = React.useState(null);
    const [users, setControlPointUsers] = React.useState([emptyUser]);

    const [labelWidth, setLabelWidth] = React.useState(0);
    const inputLabel = React.useRef(null);

    const [filterByUser, setFilterByUser] = React.useState(null);
    const [filterByEventType, setFilterByEventType] = React.useState(eventOptions[0]);
    const [orientation, setOrientation] = React.useState(sortOrientations[1]);

    const [startDate, setStartDate] = React.useState(getFirstDayOfMonth());
    const [endDate, setEndDate] = React.useState(getLastDayOfMonth());
    const [filter, setOnFilterChanged] = React.useState({
        order: sortOrientations[1].type,
        startDate: startDate,
        endDate: endDate
    });

    React.useEffect(() => {
        if (inputLabel.current !== null) {
            setLabelWidth(inputLabel.current.offsetWidth);
        }
    }, [inputLabel]);

    React.useEffect(() => {
        if (controlPoint) {
            setControlPoint(controlPoint);
        }
    }, [controlPoint]);

    React.useEffect(() => {
        if (controlPointUsers) {
            setControlPointUsers([
                emptyUser,
                ...controlPointUsers,
            ]);
        }
    }, [controlPointUsers]);


    React.useEffect(() => {
        const startDateUTC = startDate ? startDate.getTime() : null;
        const endDateUTC = endDate ? endDate.getTime() : null;

        if (startDateUTC > endDateUTC) {
            setEndDate(startDate);
        } else {
            // TODO: Update filter
            setOnFilterChanged({
                ...filter,
                startDate: startDateUTC,
                endDate: endDateUTC
            });
        }
        // eslint-disable-next-line
    }, [startDate, endDate]);

    React.useEffect(() => {
        setOnFilterChanged({
            ...filter,
            order: orientation ? orientation.type : null
        });
        // eslint-disable-next-line
    }, [orientation]);

    React.useEffect(() => {
        setOnFilterChanged({
            ...filter,
            event: filterByEventType ? filterByEventType.type : null
        });
        // eslint-disable-next-line
    }, [filterByEventType]);


    React.useEffect(() => {
        setOnFilterChanged({
            ...filter,
            userId: filterByUser ? filterByUser.key : null
        });
        // eslint-disable-next-line
    }, [filterByUser]);

    const handleFilterByUser = (e) => {
        e.persist();
        const userKey = e.target.value;
        const user = controlPointUsers.filter((user) => user.key == userKey);
        if (user && user[0]) {
            setFilterByUser(user[0]);
        } else {
            setFilterByUser(emptyUser);
        }
    }

    const handleFilterByEvent = (e) => {
        e.persist();
        const eventId = e.target.value;
        const event = eventOptions.filter((event) => event.id == eventId);
        setFilterByEventType(event[0]);
    }

    const handleSelectSortOrientation = (e) => {
        e.persist();
        const orientationId = e.target.value;
        const orientation = sortOrientations.filter((o) => o.id == orientationId);
        setOrientation(orientation[0]);
    }

    return (
        <div className={classes.root}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Card className={classes.cardContent}>
                    <Grid container direction={'row'} alignItems={'center'} justifyContent={"flex-start"} >
                        <Grid item style={{ margin: 10 }}>
                            <Typography className={classes.filterTitle}>Usuario</Typography>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel ref={inputLabel} htmlFor="outlined-age-native-simple" />
                                <Select
                                    native
                                    value={filterByUser ? filterByUser.key : ""}
                                    onChange={handleFilterByUser}
                                    labelWidth={labelWidth}
                                    inputProps={{
                                        id: "age-native-helper",
                                    }}
                                    className={classes.selector}
                                >
                                    {users.map((option, index) => (
                                        <option
                                            className={classes.option}
                                            key={index}
                                            value={option.key}
                                        >
                                            {option.email}
                                        </option>
                                    ))}
                                </Select>

                            </FormControl>
                        </Grid>

                        <Grid item style={{ margin: 10 }}>
                            <Typography className={classes.filterTitle}>Evento</Typography>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <Select
                                    native
                                    value={filterByEventType ? filterByEventType.key : ""}
                                    onChange={handleFilterByEvent}
                                    labelWidth={labelWidth}
                                    inputProps={{
                                        id: "age-native-helper",
                                    }}
                                    className={classes.selector}
                                >
                                    {eventOptions.map((option, index) => (
                                        <option
                                            className={classes.option}
                                            key={index}
                                            value={option.id}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>

                            </FormControl>
                        </Grid>

                        <Grid item style={{ margin: 10 }}>
                            <Typography className={classes.filterTitle}>Orientación</Typography>

                            <FormControl variant="outlined" className={classes.formControl}>
                                <Select
                                    native
                                    value={orientation ? orientation.id : ""}
                                    onChange={handleSelectSortOrientation}
                                    labelWidth={labelWidth}
                                    inputProps={{
                                        id: "age-native-helper",
                                    }}
                                    className={classes.selector} >
                                    {sortOrientations.map((option, index) => (
                                        <option
                                            className={classes.option}
                                            key={index}
                                            value={option.id}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>

                            </FormControl>
                        </Grid>
                        <Grid item style={{ margin: 10 }} >
                            <Typography className={classes.filterTitle}>Desde</Typography>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="none"
                                id="date-picker-inline-start"
                                value={startDate}
                                onChange={setStartDate}
                                error={false}
                                helperText={null}
                                label={null}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                                InputProps={{
                                    className: classes.componentStyle
                                }}
                            />
                        </Grid>
                        <Grid item style={{ margin: 10 }}>
                            <Typography className={classes.filterTitle}>Hasta</Typography>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant="outlined"
                                minDate={startDate}
                                format="dd/MM/yyyy"
                                margin="none"
                                id="date-picker-inline-end"
                                value={endDate}
                                onChange={setEndDate}
                                error={false}
                                helperText={null}
                                label={null}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                                InputProps={{
                                    className: classes.componentStyle
                                }}
                            />

                        </Grid>
                        <Grid item style={{ margin: 10 }}>
                            <Button
                                className={classes.createControlPointButton}
                                onClick={() => onSearch(filter)}
                            >
                                <SearchIcon style={{ float: "left" }}></SearchIcon>
                                Filtrar
                            </Button>
                        </Grid>
                    </Grid>
                </Card>
            </MuiPickersUtilsProvider>
        </div>
    );
};


export default (ControlPointActivityFilter);
